<template>
    <div class="qr-wrap">
        <div class="reader-wrap">
            <span class="qr-loading"> {{ loadingMessage }}</span>
            <div id="reader"></div>
            <button v-if="showClose" @click="closeScanner" class="close-button"></button>
        </div>
    </div>
</template>

<script>

    import {Html5Qrcode} from "html5-qrcode"
    import {mapActions, mapState} from 'vuex';

    export default {
        data() {
            return {
                html5QrCode: {},
                loadingMessage: "Loading QR Scanner...",
                showClose: false
            }
        },
        computed: {
            ...mapState([
                'discountCustomerFound',
            ]),
        },
        methods: {
            ...mapActions(['searchCustomerByQr', 'beep']),
            async ScanSuccess(decodedText, decodedResult) {
                this.beep();
                this.StopScanner();
                this.showClose = false;
                this.loadingMessage = "Searching Customer...";
                await this.searchCustomerByQr(decodedText);
                this.$emit('toggle-scanner', false);

                if(this.discountCustomerFound) {
                    this.$emit('show-customer-details', true);
                }  
            },
            StopScanner() {
                this.html5QrCode.stop().then((ignore) => {
                // QR Code scanning is stopped.
                }).catch((err) => {
                // Stop failed, handle it.
                });
            },
            closeScanner() {
                this.$emit('toggle-scanner', false);
            },
        },
        mounted() {
            this.$emit('set-button-toggle', false);
            
            this.html5QrCode = new Html5Qrcode("reader");
            const config = { fps: 10, qrbox: { width: 350, height: 350 } };

            this.html5QrCode.start({ facingMode: "environment" }, config, this.ScanSuccess);

            this.showClose = true;
        }
    }
</script>

<style lang="scss">
    .close-button {
        position: absolute;
        top: -40px;
        right: -40px;
        background: transparent;
        border: none;
        outline: none;
        width: 25px;
        height: 25px;
        cursor: pointer;

        &:before, &:after {
            content: "";
            height: 3px;
            width: 25px;
            background: #fff;
            display: block;
        }

        &:before {
                transform: rotate(45deg) translate(2px, 2px);
        }

        &:after {
            transform: rotate(-45deg);
        }
    }
</style>